import Page from "webPage/Page";
import Gallery from "webPage/Gallery";

let gallery;

Page.register('single-mphb_room_type', () => {
    let $images = $('.mphb-room-type-images:visible');

    if ($images.length > 0) {
        let interval = setInterval(function () {
            if ($images.find('.flex-viewport').length === 0 || $images.find('.gallery-item').length === 0) {
                return
            }

            clearInterval(interval);

            let $portraitImages = $images.find('.gallery-icon.portrait');

            $portraitImages.each(function () {
                let $imgsrc = $(this).find('img').attr('src');
                $(this).css("background-image", 'url('+ $imgsrc +')');
            });
        });
    }

    let $gallery = $('.js-gallery');

    if ($gallery.length > 0) {
        gallery = new Gallery($gallery, {
            itemClass:          "gallery__main-image",
            pipClass:           "gallery__pagination-item",
            navigateClass:      "js-navigate",
            pipsClass:          "js-pips",
            itemsClass:         "js-items",
            itemActiveModifier: "active",
            pipActiveModifier:  "active",
            animationDuration:  0,
        });
    }
});


